<script>
const DEFAULT_PRODUCT_IMAGE =
  'https://lupe.rappi.com/assets/images/default-product.png'

export default {
  name: 'PanelProductItemMarket',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      isSelected: false,
      complainedUnits: 1,
      quantity: 1,
      selectedProduct: {},
    }
  },
  computed: {
    productHaveImage () {
      return this.product.image.indexOf('NO-IMAGE') === -1
    },
    computedProduct () {
      return this.isSelected
        ? Object.assign({}, this.selectedProduct, {
          toppings: [],
          complainedUnits: this.complainedUnits,
          quantity: this.quantity,
          product_compensation_type: 'product',
          include: true,
        })
        : Object.assign({}, this.product, {
          include: false,
        })
    },
    computedUnits () {
      return this.product.units || this.product.pivot.units
    },
  },
  watch: {
    isSelected () {
      this.selectedProduct = this.isSelected
        ? Object.assign({}, this.product)
        : null
      this.updateProduct()
    },
    complainedUnits () {
      this.updateProduct()
    },
  },
  created () {
    if (!this.productHaveImage) this.imageFallBack()
  },
  methods: {
    imageFallBack () {
      this.product.image = DEFAULT_PRODUCT_IMAGE
      this.$forceUpdate()
    },
    increaseUnit () {
      if (this.complainedUnits < (this.product.units || this.product.pivot.units)) {
        this.complainedUnits++
        this.quantity++
      }
    },
    decreaseUnit () {
      if (this.complainedUnits > 1) {
        this.complainedUnits--
        this.quantity--
      }
    },
    updateProduct (product) {
      this.$emit('productUpdate', this.computedProduct)
    },
  },
}
</script>

<template>
  <div
    :class="$style.container"
    :id="`product-market-${$vnode.key}`"
  >
    <v-list-tile slot="activator">
      <v-flex xs1>
        <p-check
          v-model="isSelected"
          class="pretty p-image p-plain"
        >
          <img
            slot="extra"
            class="image"
            src="@assets/images/checkbox.png"
          >
        </p-check>
      </v-flex>

      <v-flex
        :class="$style.container__imgContainer"
        xs1
      >
        <img
          :src="product.image"
          :class="$style.container__img"
          @click="isSelected = !isSelected"
          @error="imageFallBack()"
        >
      </v-flex>

      <v-flex
        xs6
        offset-xs1
      >
        <p
          :class="$style.container__text"
          class="text-left"
          @click="isSelected = !isSelected"
        >
          {{ product.name }}
        </p>
      </v-flex>

      <v-flex xs3>
        <div
          v-if="isSelected && computedUnits > 1"
          :class="$style.container__counter"
        >
          <button
            :class="$style.container__counter__button"
            @click="decreaseUnit"
          >
            -
          </button>
          <div :class="$style.container__counter__text">
            {{ complainedUnits }} <span>/ {{ product.units || product.pivot.units }}</span>
          </div>
          <button
            :class="$style.container__counter__button"
            @click="increaseUnit"
          >
            +
          </button>
        </div>
      </v-flex>
    </v-list-tile>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  height: 4.715rem;
  padding: 0.5rem;
  &:not(:last-child) {
    border-bottom: 1px solid $divider-gray;
  }

  &__text {
    margin: 0;
    color: $darker-gray;
    cursor: pointer;

    @extend %typography-small;
  }

  &__imgContainer {
    margin: 0 0.5rem;
  }

  &__img {
    max-width: 3rem;
    max-height: 3rem;
    cursor: pointer;
  }

  &__counter {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-between;
    height: 2rem;
    padding: 0.2rem;
    border: 1px solid $divider-gray;
    border-radius: 5px;

    &__img {
      max-width: 0.8rem;
      max-height: 0.8rem;

      @include responsive(phone) {
        max-width: 1.4rem;
        max-height: 1.4rem;
      }
    }

    &__text {
      @extend %typography-xsmall;

      margin: 0 !important;
      text-align: center;

      @include responsive(phone) {
        font-size: 0.8rem;
      }

      span {
        color: $blue-gray;
      }
    }
    &__button {
      &:hover {
        &::after {
          opacity: 0;
          transform: scaleX(1.4) scaleY(1.4);
        }
      }
      &:active {
        transform: translateY(-0.1rem);
      }
      &:focus {
        outline: none;
      }
    }
  }
}
</style>
